<template>
  <div class="flex-1 text-center">
    <a
      class="block p-2 cursor-pointer"
      :class="sponsor ? classOverride + ' bg-brick-lighter hover:bg-brick text-brick hover:text-brick-lightest' : classOverride + ' bg-gold-lighter hover:bg-gold text-gold hover:text-gold-lighter'"
      v-bind:href="url"
      target="_blank"
      v-if="url && sponsor"
      :title="title">
        <facebook v-if="icon === 'facebook'" classes="fill-current w-4 h-4 block mx-auto"></facebook>
        <twitter v-if="icon === 'twitter'" classes="fill-current w-4 h-4 block mx-auto"></twitter>
        <instagram v-if="icon === 'instagram'" classes="fill-current w-4 h-4 block mx-auto"></instagram>
        <yelp v-if="icon === 'yelp'" classes="fill-current w-4 h-4 block mx-auto"></yelp>
        <globe v-if="icon === 'globe'" classes="fill-current w-4 h-4 block mx-auto"></globe>
    </a>
    <span
      class="block p-2 cursor-not-allowed"
      :class="sponsor ? 'bg-brick-lightest text-brick-lighter' : 'bg-grey-lightest text-grey-light'"
      v-else>
        <facebook v-if="icon === 'facebook'" classes="fill-current w-4 h-4 block mx-auto"></facebook>
        <twitter v-if="icon === 'twitter'" classes="fill-current w-4 h-4 block mx-auto"></twitter>
        <instagram v-if="icon === 'instagram'" classes="fill-current w-4 h-4 block mx-auto"></instagram>
        <yelp v-if="icon === 'yelp'" classes="fill-current w-4 h-4 block mx-auto"></yelp>
        <globe v-if="icon === 'globe'" classes="fill-current w-4 h-4 block mx-auto"></globe>
    </span>
  </div>
</template>

<script>

  import Facebook from './Facebook'
  import Twitter from './Twitter'
  import Instagram from './Instagram'
  import Yelp from './Yelp'
  import Globe from './Globe'

  export default {
    props: ['url', 'icon', 'sponsor', 'classOverride', 'title'],
    components: {
      Facebook,
      Twitter,
      Instagram,
      Yelp,
      Globe
    }
  }
</script>
